import { render, staticRenderFns } from "./OpenAIRoom.vue?vue&type=template&id=3d440aec&scoped=true&"
import script from "./OpenAIRoom.vue?vue&type=script&lang=js&"
export * from "./OpenAIRoom.vue?vue&type=script&lang=js&"
import style0 from "./OpenAIRoom.vue?vue&type=style&index=0&id=3d440aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d440aec",
  null
  
)

export default component.exports